import { UserRowRoleType } from '@modules/users/store/types';
import { UserType } from 'generated/graphql';

export const getUserTypeFromUserRowRole = (role: UserRowRoleType) => {
  switch (role) {
    case UserRowRoleType.Admin:
      return UserType.Manager;
    case UserRowRoleType.Editor:
      return UserType.Editor;
    case UserRowRoleType.Member:
      return UserType.Member;
    case UserRowRoleType.Viewer:
      return UserType.Viewer;
    default:
      return null;
  }
};
